import { render, staticRenderFns } from "./CollectionsProductsList.vue?vue&type=template&id=bc533fdc&"
import script from "./CollectionsProductsList.vue?vue&type=script&lang=ts&"
export * from "./CollectionsProductsList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsProductsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSkeletonLoader,VSubheader})
